import React, { useReducer, useEffect, useContext, useState } from "react";
import moduleConfig from "./moduleConfig";
import { Card, Row, Col } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import {
  createReducer,
  createInitialState,
} from "../../../reducers/module/createReducer";
import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import { ContainerLoading } from "../../UI/loading/ContainerLoading";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import FormErrorMessage from "../../UI/errorMessages/FormErrorMessage";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";
import CMSFormSelect from "../../UI/forms/CMSFormSelect";
import CMSFormTextArea from "../../UI/forms/CMSFormTextArea";
import { onSubmitGeneral } from "../../../helpers/ModuleHelperFunctions";

const NotificationsCreate = () => {
  const [createState, createDispatch] = useReducer(
    createReducer,
    createInitialState
  );
  const { setBreadcrumb } = useContext(BreadcrumbContext);
  let navigate = useNavigate();

  useEffect(() => {
    setBreadcrumb([
      moduleConfig.breadcrumbs.listing,
      moduleConfig.breadcrumbs.create,
    ]);
  }, []);
  return (
    <DashboardLayout>
      {createState.status == "fetching" && createState.isLoading && (
        <ContainerLoading />
      )}
      {createState.status === "fetchFailed" ? (
        <BlockErrorMessage error={createState.error} />
      ) : (
        <>
          {/* {console.log(createState.data)} */}
          {createState.status !== "fetching" && (
            <>
              <ModuleHeader
                moduleTitle={`Create ${moduleConfig.singleItemTitle}`}
                moduleUrl={moduleConfig.url}
              ></ModuleHeader>

              <section className="content">
                <Card>
                  <Card.Body>
                    {createState.isLoading && (
                      <div className="overlay position-absolute containerLoading">
                        <i className="fas fa-2x fa-sync-alt fa-spin"></i>
                      </div>
                    )}
                    <Formik
                      initialValues={{
                        importance: "Low",
                        to: "All",
                        message: "",
                      }}
                      validationSchema={yup.object({
                        importance: yup
                          .string()
                          .required("Importance is required."),
                        to: yup.string().required("Recipient is required."),
                        message: yup
                          .string()
                          .required("Message is required.")
                          .max(230, "Maximum 230 characters are allowed."),
                      })}
                      enableReinitialize={true}
                      validateOnChange={true}
                      validateOnBlur={false}
                      onSubmit={async (values) => {
                        await onSubmitGeneral(
                          values,
                          moduleConfig.url,
                          moduleConfig.url,
                          createDispatch,
                          navigate
                        );
                      }}
                    >
                      {(form) => (
                        <Form onSubmit={form.handleSubmit}>
                          {createState.error && (
                            <FormErrorMessage error={createState.error} />
                          )}

                          <Row>
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                              <CMSFormSelect
                                name="importance"
                                label="Importance"
                                options={[
                                  {
                                    value: "Low",
                                    label: "Low",
                                  },
                                  { value: "Medium", label: "Medium" },
                                  {
                                    value: "High",
                                    label: "High",
                                  },
                                ]}
                                form={form}
                                required={true}
                              />
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                              <CMSFormSelect
                                name="to"
                                label="To"
                                options={[
                                  {
                                    value: "All",
                                    label: "All",
                                  },
                                  {
                                    label: "Meal Subscribers",
                                    value: "All Meal Subscribers",
                                  },
                                     {
                                    label: "Active Meal Subscribers",
                                    value: "Active Meal Subscribers",
                                  },
                                  {
                                    label: "Expired Meal Subscriptions",
                                    value: "Expired Meal Subscribers",
                                  },
                                  {
                                    value: "Product Buyers",
                                    label: "Product Buyers",
                                  }, {
                                    value: "Customers With No Subscription",
                                    label: "Customers With No Subscription",
                                  },
                                  
                                ]}
                                form={form}
                                required={true}
                              />
                            </Col>

                            <Col
                              xs={12}
                              sm={12}
                              md={12}
                              lg={12}
                              xl={12}
                              className="mt-2"
                            >
                              <CMSFormTextArea
                                form={form}
                                label="Message"
                                name="message"
                                maxLength={230}
                                required={true}
                              />
                            </Col>
                          </Row>

                          <button
                            type="submit"
                            className="btn btn-primary mt-2"
                          >
                            Submit
                          </button>
                        </Form>
                      )}
                    </Formik>
                  </Card.Body>
                </Card>
              </section>
            </>
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default NotificationsCreate;
